import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import HomeBanner from '../../homeSliderBanner/HomeBanner';

import s from '../SliderAnimation/SliderAnimation.css';

const Layout3 = ({ title, content, homeBannerImages, isLoading }) => {
  return (
    <HomeBanner
      homeBannerImages={homeBannerImages}
      title={title}
      content={content}
      isLoading={isLoading}
    />
  );
};

export default compose(withStyles(s))(Layout3);